import { createAction } from 'redux-actions';
import { RESET, SET_PROJECTS, SET_LOADING } from './actionTypes';
import { getIncompleteProjects } from './service';
import STATUS_CODE from '../../../../request/statusCode';

const setProjects = createAction(SET_PROJECTS);

const setLoading = createAction(SET_LOADING);

const reset = createAction(RESET);

const getProjects = () => {
  return dispatch => {
    dispatch(setLoading(true));
    return getIncompleteProjects().then(res => {
      dispatch(setLoading(false));
      if (res.statusCode === STATUS_CODE.OK) {
        return dispatch(setProjects(res.data));
      }
      return dispatch(setProjects([]));
    });
  };
};

export { setProjects, reset, getProjects, setLoading };
